<template>
  <b-row>
    <b-col md="4">
      <label>Propietario*</label>
    </b-col>
    <b-col md="8">
      <select-box
        v-model="oferta.usuarioId"
        :url="urlAutocompletarUsuarios"
        :options="opcionesUsuario"
        :disabled="disabled"
      />
    </b-col>
  </b-row>
</template>

<script>
import { mapState } from "pinia";
import { useOfertaFormStore } from "@/stores/OfertaFormStore";

export default {
  props: {
    disabled: { type: Boolean, default: false },
  },
  computed: {
    ...mapState(useOfertaFormStore, ["oferta", "ofertaBase", "usuario"]),
    opcionesUsuario() {
      if (!this.usuario) {
        return [];
      }
      return [{ id: this.usuario.id, text: this.usuario.nombre }];
    },
    urlAutocompletarUsuarios() {
      const params = new URLSearchParams({
        unidadNegocioId: this.ofertaBase.unidadNegocioId || 0,
      }).toString();

      return `usuarios/autocompletar&${params}`;
    },
  },
  methods: {},
};
</script>
